import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FilterSearchPipe } from './filter.pipe';

@NgModule({
  declarations: [FilterSearchPipe], // ✅ Declare the pipe here
  imports: [CommonModule], // ✅ Import CommonModule if required
  exports: [FilterSearchPipe], // ✅ Export the pipe for use in other modules
})
export class FilterPipeModule {}
